<template>
  <v-dialog
    width="620"
    value="true"
    content-class="affiliate-dialog-delete-links-dialog"
    persistent
  >
    <v-card class="affiliate-dialog-delete-links-dialog-card">
      <v-btn
        icon
        class="affiliate-dialog-delete-links-close-btn"
        @click="closeAffiliateDeleteLinkDialog"
      >
        <close-icon class="affiliate-dialog-delete-links-close-icon" />
      </v-btn>

      <v-card-text class="affiliate-dialog-delete-links-dialog-card-text">
        <v-img
          :src="warningImage"
          width="48"
          height="48"
        />

        <div class="affiliate-dialog-delete-links-title">
          {{ $t('affiliateProgram.links.deletingCreatedLink') }}
        </div>

        <div class="affiliate-dialog-delete-links-info-text">
          {{ $t('affiliateProgram.links.deleteDialog.infoText') }}
        </div>
      </v-card-text>

      <v-card-actions class="affiliate-dialog-delete-links-card-actions">
        <v-btn
          class="affiliate-dialog-delete-links-delete-btn"
          text
          @click="handleDeleteAffiliateLink"
        >
          <span class="affiliate-dialog-delete-links-delete-btn-text">
            {{ $t('api.delete') }}
          </span>
        </v-btn>

        <v-btn
          class="affiliate-dialog-delete-links-cancel-btn"
          @click="closeAffiliateDeleteLinkDialog"
        >
          <span class="affiliate-dialog-delete-links-cancel-btn-text">
            {{ $t('common.cancel') }}
          </span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import warningImage from '@/assets/warningYellowTriangle.svg'
import CloseIcon from '@/assets/svgIcons/closeIcon.svg?inline'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AffiliateDialogDeleteLinks',
  components: {
    CloseIcon
  },
  computed: {
    ...mapGetters({
      linkForDeleting: 'affiliate/linkForDeleting'
    })
  },
  data: () => ({
    warningImage
  }),
  methods: {
    ...mapActions({
      closeDialog: 'main/closeDialog',
      getCreatingLinks: 'affiliate/getCreatingLinks',
      showAlert: 'main/alert'
    }),

    closeAffiliateDeleteLinkDialog () {
      this.closeDialog('affiliateDialogDeleteLinks')
    },

    async handleDeleteAffiliateLink() {
      try {
        await this.api.delete(`/profile/referral-links/${this.linkForDeleting}`)
        await this.showAlert({
          color: 'old-notification-success-background',
          message: this.$t('notifications.linkSuccessfullyRemoved')
        });
        await this.getCreatingLinks()
      } catch (error) {
        await this.showAlert({
          color: 'old-notification-error-background',
          message: this.$t('notifications.occurredErrorTryAgain')
        })
      } finally {
        this.closeAffiliateDeleteLinkDialog()
      }
    }
  }
}
</script>

<style lang="scss">
.affiliate-dialog-delete-links-dialog {
  border-radius: 24px;
}

.affiliate-dialog-delete-links-dialog .affiliate-dialog-delete-links-dialog-card.v-sheet.v-card {
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 24px;
  font-family: Roboto, serif;
  font-style: normal;
}

.affiliate-dialog-delete-links-wrapper-emoji,
.affiliate-dialog-delete-links-wrapper-emoji .v-image__image {
  width: 40px;
  height: 40px;
}

.affiliate-dialog-delete-links-dialog .affiliate-dialog-delete-links-title {
  margin-bottom: 16px;
  margin-top: 16px;
  color: var(--v-text-primary-base);
  font-feature-settings: 'clig' off, 'liga' off;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
}

.affiliate-dialog-delete-links-dialog .affiliate-dialog-delete-links-info-text {
  color: var(--v-text-secondary-base);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
}

.v-dialog > .v-card > .affiliate-dialog-delete-links-dialog-card-text.v-card__text {
  padding: 0;
}

.v-dialog > .v-card > .affiliate-dialog-delete-links-card-actions.v-card__actions {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 0;
  margin-top: 24px;
}

.affiliate-dialog-delete-links-card-actions button {
  margin: 0;
}

.affiliate-dialog-delete-links-dialog .v-card__actions .affiliate-dialog-delete-links-delete-btn {
  display: flex;
  height: 40px;
  padding: 0 16px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 8px;
}

.affiliate-dialog-delete-links-dialog .v-card__actions .affiliate-dialog-delete-links-delete-btn:hover::before {
  background-color: #B645EE;
}

.affiliate-dialog-delete-links-delete-btn .affiliate-dialog-delete-links-delete-btn-text {
  color: var(--v-button-tertiary-foreground-default-base);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  text-transform: none;
  letter-spacing: 0;
}

.affiliate-dialog-delete-links-dialog .v-card__actions .affiliate-dialog-delete-links-cancel-btn {
  display: flex;
  height: 40px;
  padding: 0 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: var(--v-button-primary-background-default-base);
  box-shadow: none;
}

.affiliate-dialog-delete-links-cancel-btn .affiliate-dialog-delete-links-cancel-btn-text {
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  color: var(--v-button-primary-foreground-default-base);
  text-transform: none;
  letter-spacing: 0;
}

.affiliate-dialog-delete-links-close-btn {
  position: absolute;
  top: 24px;
  right: 24px;
  width: 32px;
  height: 32px;
}

.affiliate-dialog-delete-links-close-icon {
  color: var(--v-button-secondary-gray-foreground-default-base);
  width: 24px;
  height: 24px;
}
</style>
